const Support = () => {
    return (
        <div style={{ padding: 30 }}></div>
    )
}

export default Support;
